import React, { useState, useEffect} from 'react';
import RouterComponent from './RouterComponent';
import { FormProvider  } from './context/FormContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import { split } from 'lodash';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import config from './components/config/config';

function App() {
  const pathname = window.location.href;
  // Create a URLSearchParams object from the URL
  const urlSearchParams = new URLSearchParams(new URL(pathname).search);

  // Create a new URLSearchParams object with lowercase keys
  const lowercaseSearchParams = new URLSearchParams();

  urlSearchParams.forEach((value, key) => {
    lowercaseSearchParams.set(key.toLowerCase(), value);
  });

  // Get the value of the specific parameter (e.g., "name")
  const click_get = lowercaseSearchParams.get("clickid")
  const gclid_get = lowercaseSearchParams.get("gclid")
  const linked_get = lowercaseSearchParams.get("utm_source")?.toLowerCase()
  const facebook_get = lowercaseSearchParams.get("utm_source")?.toLowerCase()

  const click_id = click_get?.replace(/"/g, '');
  const gclid = gclid_get?.replace(/"/g, '');
  const linked_in = linked_get?.replace(/"/g, '')?.toLowerCase()
  const facebook_pixel = facebook_get?.replace(/"/g, '')?.toLowerCase()

  const name = new URL(pathname)
  const pathName = split(name.pathname, '/')
  const [contactGlobal, setContactGlobal] = useState(null)
  const [emailGlobal, setEmailGlobal] = useState(null)
  const [calendlyUrl, setCalendlyUrl] = useState(null)
  const [addressGlobal, setAddressGlobal] = useState(null)
  const [calendlyUrlRealtor, setCalendlyUrlrealtor] = useState(null)
  const [calendlyRealtorWebinar, setCalendlyRealtorWebinar] = useState(null)
  const [ppgEnquiryUrl, setPpgEnquiryUrl] = useState(null)
  const [partnerContactRole, setPartnerContactRole] = useState(null)
  const [calendlyMain, setCalendlyMain] = useState(null)
  const [loaded, isLoading] = useState(true);
  const [condition, setCondition] = useState([])
  const [aboutUsList, setAboutUsList] = useState([])
  const [defectsList, setDefectsList] = useState([])
  const [conditionList, setConditionList] = useState([])
  const [leadActivityID, setLeadActivityLead] = useState(null)

  useEffect(() => {
    fetch(`${config.baseUrlCP}get_application_config/`,
      {
        headers: {
          "Authorization": `${process.env.REACT_APP_API_KEY}`,
          'Accept-Encoding': 'gzip, deflate',
        }
      })
      .then(async response => {
        const result = await response.json();
        if (response.status === 201 || response.status === 200) {
          result && result.map((res) => {
            if (res.application_config_id === 6) {
              setContactGlobal(res)
            } else if (res.application_config_id === 5) {
              setEmailGlobal(res)
            } else if (res.application_config_id === 10) {
              setCalendlyUrl(res)
            } else if (res.application_config_id === 8) {
              setAddressGlobal(res)
            } else if (res.application_config_key === "calendly_url_for_1_on_1_realtor_partner_meeting") {
              setCalendlyUrlrealtor(res)
            } else if (res.application_config_key === "calendly_url_for_calque_realtor_webinar") {
              setCalendlyRealtorWebinar(res)
            }
            if (res.application_config_id === 23) {
              setPpgEnquiryUrl(res.application_config_value)
            }
            if (res.application_config_id === 7) {
              setCalendlyMain(res)
            }
          })
        }
        else if (response.status === 403) {
        }
      }
      )
      .catch((error) => {
        console.error('error message', error)
      })

      // fetch(`${config.baseUrlCP}get-property-defects/`,
      //   {
      //     headers: {
      //       "Authorization": `${process.env.REACT_APP_API_KEY}`,
      //       'Accept-Encoding': 'gzip, deflate',
      //     }
      //   })
      //   .then(async response => {
      //     const result = await response.json();
      //     if (response.status === 201 || response.status === 200) {
      //       setDefectsList(result)
      //     }
      //     else if (response.status === 403) {
      //     }
      //   }
      //   )
      //   .catch((error) => {
      //     console.error('error message', error)
      //   })
        // fetch(`${config.baseUrlCP}get-property-condition-details/`,
        // {
        //   headers: {
        //     "Authorization": `${process.env.REACT_APP_API_KEY}`,
        //     'Accept-Encoding': 'gzip, deflate',
        //   }
        // })
        // .then(async response => {
        //   const result = await response.json();
        //   if (response.status === 201 || response.status === 200) {
        //     setConditionList(result)
        //   }
        //   else if (response.status === 403) {
        //   }
        // }
        // )
        // .catch((error) => {
        //   console.error('error message', error)
        // })
      // fetch(`${config.baseUrl}get-partner-contact-roles/`,
      //   {
      //     headers: {
      //       "Authorization": `${process.env.REACT_APP_API_KEY}`,
      //       'Accept-Encoding': 'gzip, deflate',
      //     }
      //   })
      //     .then(async response => {
      //       const result = await response.json();
      //       if (response.status === 201 || response.status === 200) {
      //         setPartnerContactRole(result)
      //       }
      //       else if (response.status === 403) {
      //       }
      //     }
      //     )
      //     .catch((error) => {
      //       console.error('error message', error)
      //     })
        // fetch(`${config.baseUrlCP}get_property_overall_condition/`,
        //   {
        //     headers: {
        //       "Authorization": `${process.env.REACT_APP_API_KEY}`,
        //       'Accept-Encoding': 'gzip, deflate',
        //     }
        //   })
        //   .then(async response => {
        //     const result = await response.json()
        //     if (response.status === 201 || response.status === 200) {
        //       setCondition(result)
        //     }
        //     else if (response.status === 403) {
        //     }
        //   }
        //   )
        //   .catch((error) => {
        //     console.error(error)
        //   })
        // fetch(`${config.baseUrlCP}get-how-did-you-hear-about-us-options/`,
        //   {
        //     headers: {
        //       "Authorization": `${process.env.REACT_APP_API_KEY}`,
        //       'Accept-Encoding': 'gzip, deflate',
        //     }
        //   })
        //   .then(async response => {
        //     const result = await response.json()
        //     if (response.status === 201 || response.status === 200) {
        //       setAboutUsList(result)
        //     }
        //   else if (response.status === 403) {
        //   }

        // }
        // )
        // .catch((error) => {
        //   console.error(error)
        // })

    if ((click_id !== null && click_id !== undefined && click_id !== '') || (gclid !== null && gclid !== undefined && gclid !== '') || (linked_in !== null && linked_in !== undefined && linked_in !== '') || (facebook_get !== null && facebook_get !== undefined && facebook_get !== '')) {
      fetch(`${config.baseUrlCP}get-third-party-lead-source/`, {
        headers: {
          'Authorization': `${process.env.REACT_APP_API_KEY}`,
          'Accept-Encoding': 'gzip, deflate',
        },
      })
        .then(async response => {
          const result = await response.json()
          if (response.status === 201 || response.status === 200) {
            result && result.map((res) => {
              if (click_id !== (null || undefined) && res.source === 'Fintel') {
                handleLeadActivityEntry(res.third_party_lead_source_id, click_id)
              } else if (gclid !== (null || undefined) && res.source === 'Google Ads') {
                handleLeadActivityEntry(res.third_party_lead_source_id, gclid)
              } else if (linked_in !== (null || undefined) && res.source === 'LinkedIn Ads' && linked_in === 'linkedin') {
                handleLeadActivityEntry(res.third_party_lead_source_id, linked_in)
              } else if (facebook_pixel !== (null || undefined) && res.source === 'Facebook Ads' && facebook_pixel === 'facebook') {
                handleLeadActivityEntry(res.third_party_lead_source_id, facebook_pixel)
              }
            })
          }
        })
        .catch((error) => {
          console.error(error)
        })
    }
    sessionStorage.setItem('property_type_id', 'none')
    sessionStorage.setItem('address', 'none')
    sessionStorage.setItem('captcha_val', 'none')
    sessionStorage.setItem('captchaFreshValue', 'none')
  }, [])

  useEffect(() => {
    if (addressGlobal && calendlyRealtorWebinar && calendlyUrl && contactGlobal && emailGlobal) {
      isLoading(false);
    }
  }, [addressGlobal, calendlyRealtorWebinar, calendlyUrl, contactGlobal, emailGlobal])

  const handleLeadActivityEntry = (leadSourceId) => {
    setLeadActivityLead(leadSourceId)
  }
  const aboutme = ['jeremy', 'peter', 'chandra', 'jim', 'megan', 'dori', 'marty', 'don', 'david']
  return (
    <FormProvider>
      {
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <div>
            {!loaded ? <RouterComponent pathname={(pathName[2] !== null && pathName[2] !== undefined && pathName[2] !== 'questionnaire') ? pathName[2]?.toLowerCase() : pathName[1]?.toLowerCase()} aboutme={aboutme} calendlyMain={calendlyMain} contactGlobal={contactGlobal} emailGlobal={emailGlobal} calendlyUrl={calendlyUrl} addressGlobal={addressGlobal} calendlyUrlRealtor={calendlyUrlRealtor} calendlyRealtorWebinar={calendlyRealtorWebinar} partnerContactRole={partnerContactRole} ppgEnquiryUrl={ppgEnquiryUrl} condition={condition} defectsList={defectsList} conditionList={conditionList} aboutUsList={aboutUsList} click_id={click_id} gclid={gclid} linked_in={linked_in} lead_activity_id={leadActivityID} facebook_pixel={facebook_pixel} /> :
              <div className='d-flex align-items-center justify-content-center' style={{ height: '100vh' }}>
                <div style={{ width: '175px' }}>
                  <img src="/assets/logos/Color_H.png" alt="Logo" width="150" height="60px" style={{ objectFit: 'contain' }}></img>
                </div>
                <div>
                  <div className="snippet" data-title=".dot-flashing">
                    <div className="stage">
                      <div className="dot-flashing mt-2"></div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </MuiPickersUtilsProvider>
      }
    </FormProvider>
  );
}

export default App;